import { render, staticRenderFns } from "./frontComentarioAsesor.vue?vue&type=template&id=a30bc642&scoped=true&"
import script from "./frontComentarioAsesor.vue?vue&type=script&lang=js&"
export * from "./frontComentarioAsesor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30bc642",
  null
  
)

export default component.exports